import { ArrivalNotice, ResponseBase, DefectNotice, LeavingNotice } from "@/models";
import axios from "axios";

export default class NoticeService {
    public async SendArrivalNotice(arrivalNotice: ArrivalNotice): Promise<ResponseBase> {
        const result = (await axios.post(`notice/arrivalnotice/create`, arrivalNotice)).data;
        return result;
    }

    public async SendDefectNotice(defectNotice: DefectNotice): Promise<ResponseBase> {
        const result = (await axios.post(`notice/defectnotice/create`, defectNotice)).data;
        return result;
    }

    public async SendLeavingNotice(leavingNotice: LeavingNotice): Promise<ResponseBase> {
        const result = (await axios.post(`notice/leavingnotice/create`, leavingNotice)).data;
        return result;
    }
}
